import {
    apiURL
} from "./baseURL"
import 'whatwg-fetch'

const quizID = 20;

const jsonPipe = response => response.json();

const usingQuizzesAPI = {
    getQuestions: callback => {
        let data = fetch(`${apiURL}GetQuestions/${quizID}`).then(jsonPipe);

        return callback ? data.then(res => callback(res)) : data;
    },
    isAlreadyExists: (body, callback) => {
        let data = fetch(`${apiURL}IsExists`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(Object.assign({
                QuizID: quizID
            }, body))
        }).then(jsonPipe);

        return callback ? data.then(res => callback(res)) : data;
    },
    saveResults: (body, callback) => {
        let data = fetch(`${apiURL}Save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(Object.assign({
                QuizID: quizID
            }, body))
        }).then(jsonPipe);

        return callback ? data.then(res => callback(res)) : data;
    }
}

export {
    usingQuizzesAPI,
    quizID
}


// WEBPACK FOOTER //
// ./src/Components/Services/fetchService.js